import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { TaktIdProvider, createStormTaktId, Flex, Switch, HelpTip } from '@amzn/storm-ui';
import { n as noop } from '../../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const ActivationAttribute = ({
  id,
  label,
  offLabel,
  active = true,
  disabled = false,
  onChange = noop,
  helptipText,
  helptipTextPosition = 'right',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('page-header-activation-attribute')
}, /*#__PURE__*/React__default.createElement(Flex, {
  alignItems: "center"
}, /*#__PURE__*/React__default.createElement(Switch, _extends({}, rest, {
  id: id,
  disabled: disabled,
  toggled: active,
  onChange: onChange,
  label: active ? label : offLabel
})), !!helptipText && /*#__PURE__*/React__default.createElement(HelpTip, {
  position: helptipTextPosition
}, helptipText)));

export { ActivationAttribute as A };
//# sourceMappingURL=ActivationAttribute-DPkhGWsT.js.map
